<template>
    <div class="card">
      <div class="card-body">
        <!-- #region Create and Refresh buttons -->
        <div class="d-flex align-items-center py-2">
          <div class="ms-auto">
            <router-link :to="`form/0`">
              <button class="btn btn-primary me-2 mb-2"><i class="uil uil-plus me-1"></i>Create Notification</button>
            </router-link>
            <button class="btn btn-secondary mb-2" @click="getNotifications()">
              <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp;&nbsp; Refresh
            </button>
          </div>
        </div>
        <!-- #endregion Create and Refresh buttons -->
  
        <!-- #region Search and Filter -->
        <div class="row p-2">
          <div class="col-md-4 col-sm-12 p-0">
            <div class="ta-right me-2">
              <b-form-group description="Search Keyword">
                <form class="d-flex" @submit.prevent="">
                  <b-form-group id="input-group-3" label-for="search-field">
                    <b-form-select
                      class="form-select rounded-0 rounded-start shadow-none w-"
                      id="search-field"
                      v-model="search.field"
                      :options="searchFieldOptions"
                      style="width: fit-content;"
                    ></b-form-select>
                  </b-form-group>
  
                  <b-input-group>
                    <b-form-input class="rounded-0 rounded-end" v-model="search.keyword"></b-form-input>
                  </b-input-group>
                </form>
              </b-form-group>
            </div>
          </div>
          <div class="col-md-2 col-sm-12 p-0">
            <div class="ta-right me-2">
              <b-form-group description="Filter by Module">
                <b-form-select
                  class="form-select rounded shadow-none dd-custom-size"
                  v-model="search.module"
                  :options="moduleList"
                ></b-form-select>
              </b-form-group>
            </div>
          </div>
          <div class="col-md-2 col-sm-12 p-0">
            <div class="ta-right me-2">
              <b-form-group description="Filter by SMS Status">
                <b-form-select
                  class="form-select rounded shadow-none dd-custom-size"
                  v-model="search.smsStatus"
                  :options="smsStatusOptions"
                ></b-form-select>
              </b-form-group>
            </div>
          </div>
  
          <div class="col-md-2 col-sm-12 p-0">
            <div class="ta-right me-2">
              <b-form-group description="Filter by App Inbox Status">
                <b-form-select
                  class="form-select rounded shadow-none dd-custom-size"
                  v-model="search.appInboxStatus"
                  :options="appInboxStatusOptions"
                ></b-form-select>
              </b-form-group>
            </div>
          </div>
  
          <!-- <div class="col-md-2 col-sm-12 p-0">
            <div class="ta-right me-2">
              <b-form-group description="Filter by date added" class="me-2 w-daterange">
                <flat-pickr
                  v-model="search.dateRange"
                  :config="rangeOptions"
                  placeholder="Select a date range"
                  class="form-control"
                ></flat-pickr>
              </b-form-group>
            </div>
          </div> -->
  
          <div class="col-md-4 col-sm-12 d-flex">
            <div class="me-2">
              <b-button variant="primary" class="h-fit d-flex align-items-center justify-content-center me-2 w-fit" @click="getNotifications">
                <i class="bx bx-search me-1 mt-1"></i>Search
              </b-button>
            </div>
            <!-- <div class="">
              <b-button
                variant="primary"
                class="h-fit me-2 d-flex align-items-center justify-content-center w-fit"
                @click="
                  isSearching = true;
                  onExport();
                "
              >
                <i class="uil uil-export me-1"></i>
                Export
              </b-button>
            </div> -->
          </div>
        </div>
        <!-- #endregion Search and Filter -->
  
        <!-- #region Table -->
        <div class="table-responsive">
          <div class="table align-middle table-nowrap">
            <b-table
              :items="peddlrNotifications"
              :fields="fields"
              responsive="sm"
              :current-page="currentPage"
              :sort-by.sync="orderBy"
              :sort-desc.sync="sortDesc"
              :filter-included-fields="filterOn"
              class="table-check"
              @sort-changed="sortList"
            >
              <template #cell(module)="data">
                <div>{{ data.item.module }}</div>
              </template>
  
              <template #cell(name)="data">
                <router-link :to="{ name: 'Notification Form', params: { id: data.item.id } }">
                    <div>{{ data.item.name }}</div>
                </router-link>
              </template>
  
              <template #cell(sms_content)="data">
                <!-- <div>{{ data.item.sms_content }}</div> -->
                <div>{{ data.item.sms_content ? `${data.item.sms_content.substring(0,50)}...` : "" }}</div>
              </template>
  
              <template #cell(app_inbox_content)="data">
                <!-- <div>{{ data.item.app_inbox_content }}</div> -->
                <div>{{ data.item.app_inbox_content ? `${data.item.app_inbox_content?.substring(0,50)}...` : ""}}</div>
              </template>
  
              <template #cell(sms_status)="data">
                <div
                  :class="{ 
                    'text-success': data.item.sms_status == 1, 
                    'text-danger': data.item.sms_status == 0
                    }"
                  >
                  {{ data.item.sms_status == 1 ? "Enabled" : "Disabled" }}
                </div>
              </template>
  
              <template #cell(app_inbox_status)="data">
                <div
                  :class="{ 
                    'text-success': data.item.app_inbox_status == 1, 
                    'text-danger': data.item.app_inbox_status == 0
                    }"
                  >
                  {{ data.item.app_inbox_status == 1 ? "Enabled" : "Disabled" }}
                </div>
              </template>
  
            </b-table>
          </div>
        </div>
        <div class="row g-0 text-center" v-if="peddlrNotificationsTotal == 0">
          <span>No data to display.</span>
        </div>
        <!-- #endregion Table -->
  
        <!-- #region Pagination -->
        <div class="row g-0 text-center text-sm-start" v-if="peddlrNotificationsTotal != 0 && peddlrNotificationsTotal > 10">
          <div class="col-sm-12">
            <div class="row">
              <div class="col">
                <div class="form-group row pull-left">
                  <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                  <div class="col-sm-6">
                    <b-form-group label-for="display-record">
                      <b-form-select
                        class="form-select shadow-none w-fit"
                        id="display-record"
                        v-model="perPage"
                        :options="pageOptions"
                        @change="getNotifications()"
                      ></b-form-select>
                    </b-form-group>
                  </div>
                </div>
                <div class="dataTables_paginate paging_simple_numbers float-end" v-if="peddlrNotificationsTotal > perPage">
                  <b-pagination
                    class="pagination-rounded"
                    v-model="currentPage"
                    @input="getNotifications()"
                    :total-rows="peddlrNotificationsTotal"
                    :per-page="perPage"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
          <!-- end col -->
        </div>
        <!-- #endregion Pagination -->
      </div>
    </div>
  </template>
  
  <script>
  import { layoutMethods, peddlrNotificationMethods, peddlrNotificationComputed, exportMethods } from "@/state/helpers";
//   import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import Swal from "sweetalert2";
  
  export default {
    page: {
      title: "Peddlr Notification Dashboard",
    },
    data() {
      return {
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        filter: null,
        filterOn: [],
        orderBy: "id",
        sort: "DESC",
        sortDesc: true,
        submitted: false,
        search: {
          keyword: "",
          field: "",
          smsStatus: "",
          module: null,
          appInboxStatus: "",
        //   dateRange: null,
        },
        rangeOptions: {
          mode: "range",
        },
        searchFieldOptions: [
          { text: "Search All", value: "" },
          { text: "Module", value: "module" },
          { text: "Name", value: "name" }
        ],
        smsStatusOptions: [
          { text: "All", value: "" },
          { text: "Enabled", value: 1 },
          { text: "Disabled", value: 0 },
        ],
        appInboxStatusOptions: [
          { text: "All", value: "" },
          { text: "Enabled", value: 1 },
          { text: "Disabled", value: 0 },
        ],
        fields: [
          { key: "module", sortable: true },
          { key: "name", sortable: true },
          { key: "sms_content", sortable: true },
          { key: "app_inbox_content", sortable: true },
          { key: "sms_status", sortable: true },
          { key: "app_inbox_status", sortable: true },
        ],
        list: [],
        moduleList: [
          { text: 'All', value: null}
        ],
      };
    },
    components: {
    //   flatPickr,
    },
    computed: {
      ...peddlrNotificationComputed,
    },
    methods: {
      ...layoutMethods,
      ...exportMethods,
      ...peddlrNotificationMethods,
      async getNotifications() {
        let params = {
          page: this.isSearching ? 1 : this.currentPage,
          rows: this.perPage,
          sort: this.sort,
          orderBy: this.orderBy,
          search: this.search,
        };
  
        await this.listPeddlrNotification(params).then(() => {
          this.isSearching = false;
        });
      },
      async sortList(action) {
        this.orderBy = action.sortBy
        this.sort = action.sortDesc ? "DESC" : "ASC";
        await this.getNotifications();
      },
      async onExport() {
        let params = {
          module: "peddlr_notifications",
          email: JSON.parse(localStorage.getItem("userData")).email,
          search: this.search,
          sort: this.sort,
          orderBy: this.orderBy,
        };
  
        this.exportReportExt(params)
          .then(() =>
            Swal.fire(
              "Success!",
              `Your request for report is pending. It will be sent to your email once it's ready.`,
              "success"
            )
          )
          .catch(() =>
            Swal.fire(
              "Failed!",
              `Your request for reports has failed.`,
              "warning"
            )
          );
      },
      getModuleList() {
        var self = this;
        this.listPeddlrNotificationModules()
        .then(async () => {
            for(let data of this.peddlrNotificationModules){
              self.moduleList.push({ 'text': data.module, 'value': data.module })
            }
        })
      },
    },
    async mounted() {
      this.changeTitle({ title: "Notification Settings" });
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: "Peddlr", to: { name: "Home" } },
          { text: "Notification", to: { name: "" } },
        ],
      });

      await this.getNotifications();
      this.getModuleList()
    },
  };
  </script>
  
  <style scoped>
  /* .dd-custom-size {
    width: 200px;
  }
  
  .w-daterange {
    width: 12.9rem;
  } */
  </style>
  